import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { OfbizForm } from '@urbannex/ofbiz-forms';
import { OfbizList, RemoteFormData } from '@urbannex/ofbiz-forms';
import { Observable, Subject,Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ActionState, ComponentConfig, OutGoingLink } from '../../shared/model';
import { UbsComponentStoreService } from '../../ubs-component-store.service';
import { UpdateComponentStoreService } from '../../update-component-store.service';
import { RelationService } from '../relation.service';
import { ViewContainersService } from '../../shared/services/view-containers.service';
import { NbWindowConfig, NbWindowService, NbWindowState } from '@nebular/theme';
import { WindowContainerComponent } from '../../window-container/window-container.component';


@Component({
  selector: 'ubs-relation-list-container',
  templateUrl: './relation-list-container.component.html',
  styleUrls: ['./relation-list-container.component.scss'],
})
export class RelationListContainerComponent implements OnInit,OnChanges,OnDestroy {
@Input() listForm:OfbizList;
@Input() addForm:OfbizForm;
@Input() parameters:any;
@Input() title:string;
@Input() appContext:string;
remoteFormData:RemoteFormData;
/* remoteFormData:RemoteFormData = {
  formData:{
    formLocation:"",
    formName:"",
    listType:"",
  },
  endPoint:"",
  parameters:{}
} */
fieldOptions:any;
listOptions:any = {};
columnFields:any = {};

viewMode:string = "collapsible";
refreshSubscription:Subscription;
refreshList$:boolean;
outGoingLinks:OutGoingLink[];
action:ActionState;

readonly selectedRow$ = this.relationService.getSelectedRow();

private readonly destroy$ = new Subject<void>(); 


@ViewChild("container", {read: ElementRef}) container: ElementRef;

@Output() selectedRow = new EventEmitter<any>();

  constructor(
    private componentStore:UbsComponentStoreService,
    private relationService:RelationService,
    private updateComponentStoreService:UpdateComponentStoreService,
    private router:Router,
    private windowService: NbWindowService,
    private viewContainersService:ViewContainersService) { 
      
      this.componentStore.componentConfig$.pipe(takeUntil(this.destroy$))
      .subscribe((componentConfig:ComponentConfig) => {
        console.log({ComponentConfig:componentConfig});        
          if(componentConfig.outGoingLinks){
            console.log({OutGoingLinks:componentConfig})
            this.outGoingLinks = componentConfig.outGoingLinks;
          }
          if(componentConfig.defaultAction){
            this.action = componentConfig.defaultAction;
          }      
      })
  }

  ngOnInit(): void {
    this.relationService.getRefreshList()
    .pipe(takeUntil(this.destroy$))
    .subscribe((execute:boolean) => {
      this.refreshList$ = execute;
      console.log({RefreshList:this.refreshList$,Component:"RelationListContainerComponent",Comment:"Getting state from subscription"})
    });
    this.selectedRow$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.selectedRow.emit(data)
    })
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["listForm"]){
      console.log({RelationList:this.listForm});
      console.log({findParameters:this.listForm.findParameters});
      if(this.listForm.remoteFormData != undefined && this.listForm.remoteFormData != null){
        this.remoteFormData = this.listForm.remoteFormData;
        console.log({findParameters:this.listForm.findParameters});
        if(this.listForm?.findParameters){
          this.remoteFormData["parameters"] = {};
          this.listForm.findParameters.forEach(findParameter => {
            console.log(findParameter);
            Object.keys(findParameter).forEach(key => {
              this.remoteFormData["parameters"][key] = findParameter[key];
              //this.remoteFormData["formData"][key] = findParameter[key];
            })
          });
        }
        console.log("Track RemoteFormData Change",this.remoteFormData);
      }else{
        this.remoteFormData = {
          formData:{
            listType:this.listForm?.listType,
            formName:this.listForm.listFormName,
            formLocation:this.listForm.listFormLocation,
            viewIndex:this.listForm.viewIndex
          },
            endPoint:this.listForm.endPoint
        };
      }
      
      /* if(this.parameters){
        console.log({ParametersRelationList:this.parameters});
        this.remoteFormData.parameters = this.parameters;
      }else if(this.listForm?.findParameters){
        console.log({findParameters:this.listForm.findParameters});
        this.remoteFormData["parameters"] = {};
        this.listForm.findParameters.forEach(findParameter => {
          console.log(findParameter);
          Object.keys(findParameter).forEach(key => {
            this.remoteFormData["parameters"][key] = findParameter[key];
          })
        });
        console.log({findParameters:this.remoteFormData["parameters"]});
      } */


      this.fieldOptions = this.listForm.fieldFormFields;

      this.listOptions.formName = this.listForm.listFormName;
      this.listOptions.entityName = this.listForm.entityName;
      this.listOptions.formLocation = this.listForm.listFormLocation;
      if(this.listForm.viewIndex){
        this.listOptions.viewIndex = this.listForm.viewIndex;
      }
      if(this.listForm.endPoint){
        this.listOptions.endPoint = this.listForm.endPoint;
      }
      if(this.listForm.columnFields){
        this.columnFields = this.listForm.columnFields;
      }
      if(this.listForm.labelColumn){
        this.listOptions.labelColumn = this.listForm.labelColumn;
      }
      if(this.listForm.listType != undefined){
        this.remoteFormData.formData.listType = this.listForm.listType;
      }
      if(this.listForm.target){
        this.listOptions.target = this.listForm.target;
      }
      console.log({RelationList:this.listForm,RemoteFormData:this.remoteFormData,FieldOptions:this.fieldOptions,ListOptions:this.listOptions,ColumnFields:this.columnFields});
    }
    if(changes["addForm"]){
      this.listOptions.addForm = this.addForm;
    }
    if(changes["appContext"]){
      this.remoteFormData.appContext = this.appContext;
    }
  }

  handleHyperLinkSelected(e){
    console.log({TrackSelectedValue:e});
    if(this.outGoingLinks){
      console.log({outGoingLinksRelationList:this.outGoingLinks,Incoming:e})
      let outGoingLink = this.outGoingLinks.find(outGoingLink => outGoingLink.target === e.target);
      outGoingLink.targetType = e.targetType;
      outGoingLink.segments.forEach(segment => {
        console.log({Segment:segment})
        if(e.parameters.hasOwnProperty(segment.parameter)){
          outGoingLink.parameters[segment.parameter] = e.parameters[segment.parameter];
          segment.parameter = e.parameters[segment.parameter];
        }  
      });
      outGoingLink.targetType = e.targetType? e.targetType: "";
      outGoingLink.remoteFormData = e.remoteFormData? e.remoteFormData:null;
      //outGoingLink.parameters = e.parameters;
      console.log({outGoingLink:outGoingLink});
      this.updateComponentStoreService.setOutGoingLink(outGoingLink);
      //this.componentStore.updateOutGoingLink(outGoingLink);
      if(outGoingLink.targetType == "intra-app"){
        let url = "admin/pms";
        outGoingLink.segments.forEach(segment => {
          url = url+"/"+segment.pathElement+"/"+segment.parameter
        })
        this.router.navigateByUrl(url, { skipLocationChange: false });
        console.log(outGoingLink);
      }
      //this.componentStore.updateOutGoingLink(outGoingLink);
      /* const urlSegmentGroup: Observable<string> = this.route.url.pipe(map(segments => segments.join('')));
      urlSegmentGroup.subscribe(data => {
        console.log(data)
      }); */
    }else{
      console.log("There is no outgoing links")
      if(e.targetType == "intra-app"){
        let link = e.formData.link;
        let windowData = {
          title: e["target"],
          initialState: NbWindowState.MAXIMIZED,
          hasBackdrop: true,
          closeOnBackdropClick: true,
          closeOnEsc: true,
          windowClass: 'inter-app-window',
          context:{
            link:link
          }
         // viewContainerRef: undefined,
          /* buttons: undefined,
          applyDefaultButtonConfig: function (): void {
            throw new Error('Function not implemented.');
          } */
        }
        this.windowService.open(WindowContainerComponent,windowData)
        //this.router.navigateByUrl(link, { skipLocationChange: false });
      }
    } 

  }
  /**
   * Function gets data from list and notifies header via ViewContainersService
   * Data is only sent if getList return a list successfully
   * Data is used in breadCrumb creation
   * @param data : RemoteFormData
   */
  handleListSucessNotify(data:any):void{
    console.log("successData in ListContainerComponent",data.rows);
    //this.viewContainersService.setNotifiedSuccess(data);
    //Set the first row as selected
    let rows:any[] = data.rows;
    if(rows && rows.length > 0){
      let firstRow = rows[0];
      console.log({FirstRow:firstRow},this.action);
      if(this.action && this.action == ActionState.MASTERDETAIL){
        this.relationService.setSelectedRow(firstRow); 
      }
    }
  }

  collapseExpandContainer(e){
    console.log({TrackCollapse:e});
    if(e == false){
      this.container.nativeElement.style.display = "none";
    }else{
      this.container.nativeElement.style.display = "block";
    }
  }

  rowSelected(e){
    //Convert row data object into an array of objects
    const rowObjects = Object.entries(e.data).map(([key, value]) => ({ [key]: value }));
    this.relationService.setSelectedRow(rowObjects);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    //this.refreshSubscription.unsubscribe();
  }

}
